import { defineComponent as _defineComponent } from 'vue'
import { MONTHS_SHORT, type DayCell, type RangeDirection } from '../datepicker';


const __default__ = {
    name: 'UiCalendar',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    cells: null,
    title: null,
    rangeDirection: { default: null },
    showPrev: { type: Boolean, default: true },
    showNext: { type: Boolean, default: true },
    staticTitle: { type: Boolean, default: false },
    showMonthPicker: { type: Boolean, default: false },
    viewYear: { default: 0 },
    viewMonth: { default: 0 }
  },
  emits: ["prev", "next", "toggle-month-picker", "day-click", "day-hover", "day-leave", "prev-year", "next-year", "select-view-month"],
  setup(__props: any) {

const WEEKDAYS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];





return { __sfc: true,WEEKDAYS, MONTHS_SHORT }
}

})